import { createDefaultTextStyle, buildComputedTextStyle, normalizeTextStyle } from "./textStyle";

const createId = () => `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;

export const createTextSegment = (overrides = {}) => ({
  id: createId(),
  text: "",
  textStyle: createDefaultTextStyle(),
  ...overrides,
});

/** Prefer segment list; fall back to a single plain-string segment. */
export const normalizeTextSegments = (segments, plainText = "") => {
  if (Array.isArray(segments) && segments.length > 0) {
    return segments.map((segment) => ({
      id: segment.id || createId(),
      text: segment.text || "",
      textStyle: segment.textStyle || createDefaultTextStyle(),
      textColor: segment.textColor,
    }));
  }

  if (plainText) {
    return [createTextSegment({ text: plainText })];
  }

  return [];
};

export const joinSegmentText = (segments = []) =>
  segments.map((segment) => segment.text || "").join("");

export const buildSegmentComputedStyle = (segment, defaults = {}, siteFontFamily) =>
  buildComputedTextStyle(
    normalizeTextStyle(segment?.textStyle, segment?.textColor),
    defaults,
    siteFontFamily
  );
